import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  aiConfigService,
  type AiConfig,
  type AiConfigWithModels,
  type SelectableModel,
  type UpdateAiConfigPayload,
} from "@/services/aiConfigService";

interface AiConfigState {
  config: AiConfig | null;
  allowedModels: SelectableModel[];
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: AiConfigState = {
  config: null,
  allowedModels: [],
  loading: false,
  saving: false,
  error: null,
};

export const fetchAiConfig = createAsyncThunk<AiConfigWithModels>(
  "aiConfig/fetch",
  async () => aiConfigService.getConfig(),
);

export const updateAiConfig = createAsyncThunk<AiConfig, UpdateAiConfigPayload>(
  "aiConfig/update",
  async (payload) => aiConfigService.updateConfig(payload),
);

const aiConfigSlice = createSlice({
  name: "aiConfig",
  initialState,
  reducers: {
    setAiConfigError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAiConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAiConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload.config;
        state.allowedModels = action.payload.allowedModels;
      })
      .addCase(fetchAiConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Erreur de chargement";
      })
      .addCase(updateAiConfig.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateAiConfig.fulfilled, (state, action) => {
        state.saving = false;
        state.config = action.payload;
      })
      .addCase(updateAiConfig.rejected, (state, action) => {
        state.saving = false;
        state.error = action.error.message ?? "Erreur de mise à jour";
      });
  },
});

export const { setAiConfigError } = aiConfigSlice.actions;
export default aiConfigSlice.reducer;
